module.exports = __webpack_public_path__ + "static/media/fedpa-thumbs.29a3d492.svg";